import { useRouter } from "next/navigation"
import React, { useState } from "react"
import Cookies from "js-cookie"

const FlyButton = ({ dataEventState, openPopup }) => {
  const router = useRouter()
  const [open, setOpen] = useState(true)
  const onRedirect = () => {
    if (dataEventState?.link) window.open(dataEventState?.link, "_blank", "noopener,noreferrer")
  }
  return (
    <>
      {open && dataEventState?.icon_img && (
        <div
          className={`fixed w-[120px] h-[120px] sm:w-[150px] sm:h-[150px] md:w-[170px] md:h-[170px] 2xl:w-[288px] 2xl:h-[288px] bottom-14 right-4 md:right-6 md:bottom-0 ${
            openPopup ? "z-10" : "z-[100]"
          }`}
        >
          <img
            onClick={onRedirect}
            className="w-full h-full object-contain cursor-pointer"
            src={dataEventState?.icon_img}
            alt=""
          />
        </div>
      )}
    </>
  )
}

export default FlyButton
